import http from "./config/http-configs";

export const getVisitorStatistic = () => {
    return http.get('/mobile/statistic/trip/number/visitor')
}

export const getEmployeeStatistic = () => {
    return http.get('/mobile/statistic/trip/number/employee')
}
